declare global {
  interface Window {
    Swiper: any;
  }
}

export function initBf10GridSlider(root: ParentNode = document): void {
  const sliders = root.querySelectorAll<HTMLElement>('.bf-10-grid-slider');
  if (!sliders.length) return;

  if (typeof window.Swiper !== 'function') {
    setTimeout(() => initBf10GridSlider(root), 50);
    return;
  }

  sliders.forEach((slider) => {
    if (slider.dataset.init === 'true') return;
    slider.dataset.init = 'true';

    const slides = slider.querySelectorAll('.bf-10-grid-slide');

    const updateText = (swiper: any) => {
      const realIndex = swiper.realIndex;
      
      slides.forEach((slide, index) => {
        const textElement = slide.querySelector('.bf-10-grid-text') as HTMLElement;
        if (!textElement) return;
        
        if (index === realIndex) {
          textElement.textContent = realIndex === 0 ? "Mach's Beige" : "Mach's Bunt";
        }
      });
    };

    new window.Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      speed: 1,
      allowTouchMove: false,
      loopAdditionalSlides: 2,
      watchSlidesProgress: true,
      cssMode: false,
      on: {
        init: function (swiper: any) {
          updateText(swiper);
        },
        slideChange: function (swiper: any) {
          updateText(swiper);
        }
      }
    });
  });
}

